<div class="wizard-stepper">
  @if (showProgress) {
    <div class="wizard-stepper__progress" role="progressbar" [attr.aria-valuenow]="progressValue" aria-valuemin="0" aria-valuemax="100">
      <div class="wizard-stepper__progress-bar" [style.width.%]="progressValue"></div>
    </div>
  }

  @if (showActions) {
    <div class="wizard-stepper__actions">
      <button type="button" (click)="back.emit()" [disabled]="!canGoBack" class="wizard-stepper__back" mat-flat-button data-test="btn-wizard-back">
        <mat-icon>chevron_left</mat-icon>
        {{ backLabelKey | translate }}
      </button>

      @if (showFinishOnLastStep && isLastStep) {
        <button type="button" (click)="finish.emit()" [disabled]="!canFinish" color="primary" mat-flat-button data-test="btn-wizard-finish">
          <mat-icon>check</mat-icon>
          {{ finishLabelKey | translate }}
        </button>
      } @else {
        <button type="button" (click)="next.emit()" [disabled]="!canGoNext" color="primary" mat-flat-button data-test="btn-wizard-next">
          {{ nextLabelKey | translate }}
          <mat-icon>chevron_right</mat-icon>
        </button>
      }
    </div>
  }
</div>
